import { blue, blueGrey, deepOrange, grey, yellow } from "@mui/material/colors";
import { DateTime } from "luxon";

export const AllowedGraphTypes = [
  "hazardousWaste",
  "hazardousWasteByMonth",
  "highestGeneratingWasteStreams",
] as const;

export type AllowedGraphType = (typeof AllowedGraphTypes)[number];

export function formatMonth(date: string, isFirstMonth: boolean) {
  const month = DateTime.fromFormat(date, "yyyy-MM-dd");
  if (month.month === 1 || isFirstMonth) {
    return month.toFormat("LLL\nyyyy");
  }
  return month.toFormat("LLL");
}

export const colorMap = {
  "Vendor Hazardous": deepOrange[300],
  "e‑Manifest Hazardous": blueGrey[100],
  "Vendor Acute": deepOrange[800],
  "e‑Manifest Acute": blueGrey[300],
  "Vendor State Regulated": yellow[700],
  "e‑Manifest State Regulated": blue[200],
  // Pounds an episodic event excludes from status, stacked back on each source's
  // bar so the bar still reaches what that source reported. One muted neutral
  // for both stacks: the blue-greys belong to the e‑Manifest layers.
  "Episodic (excluded)": grey[400],
};
